import { axios } from '@Root/API'

export const getAllById = params => {
  return axios.get(`students/rollover/info`, { params })
}
